import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComputerMapped = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 15 15",
	fill: "currentColor",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M14.21 12.63H.79a.79.79 0 100 1.58H14.2a.79.79 0 100-1.58zM13.86 0H1.14C.51 0 0 .51 0 1.14v9.56c0 .63.51 1.14 1.14 1.14h12.72c.63 0 1.14-.51 1.14-1.14V1.14C15 .51 14.49 0 13.86 0z" }),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.42 1.58H1.58v8.68h11.84V1.58z",
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("path", { d: "M10.4 3.17l1.13 1.12-4.47 4.47-2.8-2.8 1.12-1.1 1.68 1.67 3.35-3.36z" })
	]
});
export default SvgComputerMapped;
